import { render } from "./ProfileBox.vue?vue&type=template&id=c44aaaea&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&lang=js"
export * from "./ProfileBox.vue?vue&type=script&lang=js"

import "./ProfileBox.vue?vue&type=style&index=0&id=c44aaaea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44aaaea"]])

export default __exports__